import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

const Login = lazy(() => import("./Login"));
const Dashboard = lazy(() => import("./Dashboard"));
const Admin = lazy(() => import("./Admin"));
const SelectionPage = lazy(() => import("./SelectionPage"));
const BloodCholesterolPage = lazy(() => import("./BloodCholesterolPage"));
const FullHealthScreenPage = lazy(() => import("./FullHealthScreenPage"));
const NurseChatPage = lazy(() => import("./NurseChatPage"));
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  return isAuthenticated ? children : <Navigate to="/login" />;
};

const AppRoutes = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<SelectionPage />} />
        <Route
          path="/screen"
          element={<Navigate to="/screen/full-health-screen" replace />}
        />
        <Route
          path="/screen/blood-cholesterol-checks"
          element={<BloodCholesterolPage />}
        />
        <Route
          path="/screen/full-health-screen"
          element={<FullHealthScreenPage />}
        />
        <Route path="/screen/nurse-chat" element={<NurseChatPage />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
